<div class="row g-4 my-3">
  <div class="col-lg-4 col-md-5">
    <mat-card class="create-card shadow-sm border-0 rounded-4 overflow-hidden">
      <div class="header-bg d-flex justify-content-between align-items-center">
        <h5 class="m-0 d-flex align-items-center">
          <mat-icon class="mr-2">add_chart</mat-icon>
          {{ 'components.custom-charts.create-new-analysis' | translate }}
        </h5>
        <button mat-icon-button (click)="openHelpDialog()" class="text-white" [title]="'components.custom-charts.help.title' | translate">
          <mat-icon>help_outline</mat-icon>
        </button>
      </div>
      <mat-card-content class="pt-4">
        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.chart-title' | translate }}</mat-label>
            <input matInput [(ngModel)]="newChartTitle" [placeholder]="'components.custom-charts.chart-title-placeholder' | translate">
            <mat-icon matSuffix class="text-muted">title</mat-icon>
          </mat-form-field>
        </div>

        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.chart-type' | translate }}</mat-label>
            <mat-select [(ngModel)]="newChartType">
              <mat-option value="bar">{{ 'components.custom-charts.type-bar' | translate }}</mat-option>
              <mat-option value="line">{{ 'components.custom-charts.type-line' | translate }}</mat-option>
              <mat-option value="pie">{{ 'components.custom-charts.type-pie' | translate }}</mat-option>
              <mat-option value="scatter">{{ 'components.custom-charts.type-scatter' | translate }}</mat-option>
              <mat-option value="heatmap">{{ 'components.custom-charts.type-heatmap' | translate }}</mat-option>
            </mat-select>
            <mat-icon matSuffix class="text-muted">show_chart</mat-icon>
          </mat-form-field>
        </div>

        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.x-axis' | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedXAxis">
              @if (customFieldDimensions.length) {
                <mat-optgroup [label]="'components.custom-charts.member-custom-fields' | translate">
                  @for (dim of customFieldDimensions; track dim) {
                    <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                  }
                </mat-optgroup>
              }
              <mat-optgroup [label]="'components.custom-charts.survey-questions' | translate">
                @for (dim of questionDimensions; track dim) {
                  <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                }
              </mat-optgroup>
            </mat-select>
            <mat-hint>{{ 'components.custom-charts.x-axis-hint' | translate }}</mat-hint>
          </mat-form-field>
        </div>

        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.group-by' | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedGroupBy">
              <mat-option [value]="null">{{ 'components.custom-charts.no-grouping' | translate }}</mat-option>
              <mat-optgroup [label]="'components.custom-charts.member-custom-fields' | translate">
                @for (dim of customFieldDimensions; track dim) {
                  <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                }
              </mat-optgroup>
              <mat-optgroup [label]="'components.custom-charts.survey-questions' | translate">
                @for (dim of questionDimensions; track dim) {
                  <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                }
              </mat-optgroup>
            </mat-select>
            <mat-hint>{{ 'components.custom-charts.group-by-hint' | translate }}</mat-hint>
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-actions class="px-3 pb-4 d-grid row justify-content-center">
        <button mat-flat-button color="primary" class="rounded-3 py-2"
                [disabled]="!newChartTitle || !selectedXAxis || creating"
                (click)="createNewChart()">
          @if (creating) {
            <mat-spinner diameter="20" class="mr-2 d-inline-block"></mat-spinner>
          } @else {
            <mat-icon class="mr-2">insights</mat-icon>
          }
          {{ 'components.custom-charts.generate-analysis' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>

    <ng-template #helpDialog>
      <h2 mat-dialog-title class="d-flex align-items-center m-0 p-3 fw-bold border-bottom brand-title">
        <mat-icon class="mr-2 brand-icon">tips_and_updates</mat-icon>
        {{ 'components.custom-charts.help.title' | translate }}
      </h2>
      <mat-dialog-content class="p-3 help-dialog-content">
        <p class="small text-muted mb-3">
          {{ 'components.custom-charts.help.description' | translate }}
        </p>

        <mat-accordion class="help-accordion" [multi]="false">
          <!-- 1. Scelta Singola / Multipla -->
          <mat-expansion-panel class="border-0 shadow-none mb-2 rounded-3">
            <mat-expansion-panel-header class="px-2">
              <mat-panel-title class="small fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-1 small-icon">list</mat-icon>
                {{ 'components.custom-charts.help.cat1.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small help-panel-content">
              <div class="mb-2"><strong>{{ 'components.custom-charts.help.best-combo' | translate }}:</strong></div>
              <ul class="pl-3 mb-2">
                <li><strong>X-Axis:</strong> {{ 'components.custom-charts.help.cat1.x' | translate }}</li>
                <li><strong>Group By:</strong> {{ 'components.custom-charts.help.cat1.group' | translate }}</li>
              </ul>
              <p class="m-0 text-muted">
                {{ 'components.custom-charts.help.cat1.desc' | translate }}
              </p>
            </div>
          </mat-expansion-panel>

          <!-- 2. Consenso & Booleano -->
          <mat-expansion-panel class="border-0 shadow-none mb-2 rounded-3">
            <mat-expansion-panel-header class="px-2">
              <mat-panel-title class="small fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-1 small-icon">handshake</mat-icon>
                {{ 'components.custom-charts.help.cat2.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small help-panel-content">
              <div class="mb-2"><strong>{{ 'components.custom-charts.help.best-combo' | translate }}:</strong></div>
              <ul class="pl-3 mb-2">
                <li><strong>X-Axis:</strong> {{ 'components.custom-charts.help.cat2.x' | translate }}</li>
                <li><strong>Group By:</strong> {{ 'components.custom-charts.help.cat2.group' | translate }}</li>
              </ul>
              <p class="m-0 text-muted">
                {{ 'components.custom-charts.help.cat2.desc' | translate }}
              </p>
            </div>
          </mat-expansion-panel>

          <!-- 3. Quantitativo / Numerico -->
          <mat-expansion-panel class="border-0 shadow-none mb-2 rounded-3">
            <mat-expansion-panel-header class="px-2">
              <mat-panel-title class="small fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-1 small-icon">calculate</mat-icon>
                {{ 'components.custom-charts.help.cat3.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small help-panel-content">
              <div class="mb-2"><strong>{{ 'components.custom-charts.help.best-combo' | translate }}:</strong></div>
              <ul class="pl-3 mb-2">
                <li><strong>X-Axis:</strong> {{ 'components.custom-charts.help.cat3.x' | translate }}</li>
                <li><strong>Group By:</strong> {{ 'components.custom-charts.help.cat3.group' | translate }}</li>
              </ul>
              <p class="m-0 text-muted">
                {{ 'components.custom-charts.help.cat3.desc' | translate }}
              </p>
            </div>
          </mat-expansion-panel>

          <!-- 4. Griglia & Classificazione -->
          <mat-expansion-panel class="border-0 shadow-none mb-2 rounded-3">
            <mat-expansion-panel-header class="px-2">
              <mat-panel-title class="small fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-1 small-icon">grid_on</mat-icon>
                {{ 'components.custom-charts.help.cat4.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small help-panel-content">
              <div class="mb-2"><strong>{{ 'components.custom-charts.help.best-combo' | translate }}:</strong></div>
              <ul class="pl-3 mb-2">
                <li><strong>X-Axis:</strong> {{ 'components.custom-charts.help.cat4.x' | translate }}</li>
                <li><strong>Group By:</strong> {{ 'components.custom-charts.help.cat4.group' | translate }}</li>
              </ul>
              <p class="m-0 text-muted">
                {{ 'components.custom-charts.help.cat4.desc' | translate }}
              </p>
            </div>
          </mat-expansion-panel>

          <!-- 5. Ranking & Allocazione -->
          <mat-expansion-panel class="border-0 shadow-none mb-2 rounded-3">
            <mat-expansion-panel-header class="px-2">
              <mat-panel-title class="small fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-1 small-icon">sort</mat-icon>
                {{ 'components.custom-charts.help.cat5.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small help-panel-content">
              <div class="mb-2"><strong>{{ 'components.custom-charts.help.best-combo' | translate }}:</strong></div>
              <ul class="pl-3 mb-2">
                <li><strong>X-Axis:</strong> {{ 'components.custom-charts.help.cat5.x' | translate }}</li>
                <li><strong>Group By:</strong> {{ 'components.custom-charts.help.cat5.group' | translate }}</li>
              </ul>
              <p class="m-0 text-muted">
                {{ 'components.custom-charts.help.cat5.desc' | translate }}
              </p>
            </div>
          </mat-expansion-panel>

          <!-- 6. Scelta del Grafico -->
          <mat-expansion-panel class="border-0 shadow-none mb-2 rounded-3">
            <mat-expansion-panel-header class="px-2">
              <mat-panel-title class="small fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-1 small-icon">insert_chart</mat-icon>
                {{ 'components.custom-charts.help.chart-types.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small help-panel-content">
              <ul class="pl-3 m-0">
                <li class="mb-2">{{ 'components.custom-charts.help.chart-types.pie' | translate }}</li>
                <li class="mb-2">{{ 'components.custom-charts.help.chart-types.bar' | translate }}</li>
                <li class="mb-2">{{ 'components.custom-charts.help.chart-types.line' | translate }}</li>
                <li class="mb-2">{{ 'components.custom-charts.help.chart-types.scatter' | translate }}</li>
                <li>Heatmap: {{ 'components.custom-charts.type-heatmap' | translate }}</li>
              </ul>
            </div>
          </mat-expansion-panel>

          <!-- 7. Incrociare due Domande -->
          <mat-expansion-panel class="border-0 shadow-none rounded-3">
            <mat-expansion-panel-header class="px-2">
              <mat-panel-title class="small fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-1 small-icon">compare_arrows</mat-icon>
                {{ 'components.custom-charts.help.q2q.title' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small help-panel-content">
              <p class="m-0 text-muted">
                {{ 'components.custom-charts.help.q2q.desc' | translate }}
              </p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-dialog-content>
      <mat-dialog-actions class="justify-content-end p-2 border-top">
        <button mat-flat-button color="primary" mat-dialog-close class="rounded-3">
          {{ 'generic.buttons.close' | translate }}
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <div class="col-lg-8 col-md-7">
    @if (loading) {
      <div class="d-flex flex-column align-items-center justify-content-center py-5">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="mt-3 text-muted">{{ 'components.custom-charts.loading' | translate }}</p>
      </div>
    }

    @if (!loading) {
      @for (chart of charts; track chart.id) {
        <mat-card class="chart-container mb-4 shadow-sm border-0 rounded-4 overflow-hidden">
            <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
              <h6 class="m-0 fw-bold d-flex align-items-center text-dark">
                <mat-icon class="mr-2 text-primary">analytics</mat-icon>
                {{chart.title}}
              </h6>
              <div class="d-flex align-items-center">
                <button mat-icon-button (click)="openInfoDialog(chart)" [title]="'components.custom-charts.analysis-details' | translate" class="text-info mr-1">
                  <mat-icon size="small">info_outline</mat-icon>
                </button>
                <button mat-icon-button (click)="openEditDialog(chart)" [title]="'generic.buttons.modify' | translate" class="text-primary mr-1">
                  <mat-icon size="small">edit</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteChart(chart.id)" [title]="'components.custom-charts.delete-analysis' | translate" class="text-danger">
                  <mat-icon size="small">delete_outline</mat-icon>
                </button>
              </div>
            </div>
           <mat-card-content class="p-0">
             @if (chartDataMap[chart.id]) {
                <div echarts [options]="chartDataMap[chart.id]" class="chart-content"></div>
             } @else {
                <div class="d-flex flex-column justify-content-center align-items-center chart-placeholder">
                  <mat-spinner diameter="30"></mat-spinner>
                  <span class="mt-2 text-muted small">{{ 'components.custom-charts.processing-data' | translate }}</span>
                </div>
             }
           </mat-card-content>
        </mat-card>
      }

      @if (charts.length === 0) {
        <div class="empty-state text-center py-5 px-4 bg-light rounded-4">
          <div class="icon-square shadow-sm mb-4">
            <mat-icon>query_stats</mat-icon>
          </div>
          <h4 class="fw-bold">{{ 'components.custom-charts.no-charts-title' | translate }}</h4>
          <p class="text-muted mb-4 mx-auto" style="max-width: 400px;">
            {{ 'components.custom-charts.no-charts-hint' | translate }}
          </p>
        </div>
      }
    }
  </div>
</div>

<ng-template #editDialog>
  <h2 mat-dialog-title class="d-flex align-items-center m-0 p-3 fw-bold border-bottom brand-title">
    <mat-icon class="mr-2 brand-icon">edit</mat-icon>
    {{ 'generic.buttons.modify' | translate }}
  </h2>
  <mat-dialog-content class="p-3">
    <div class="mb-3">
      <mat-form-field appearance="outline" class="w-100 custom-field">
        <mat-label>{{ 'components.custom-charts.chart-title' | translate }}</mat-label>
        <input matInput [(ngModel)]="editChartTitle" [placeholder]="'components.custom-charts.chart-title-placeholder' | translate">
        <mat-icon matSuffix class="text-muted">title</mat-icon>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" class="w-100 custom-field">
        <mat-label>{{ 'components.custom-charts.chart-type' | translate }}</mat-label>
        <mat-select [(ngModel)]="editChartType">
          <mat-option value="bar">{{ 'components.custom-charts.type-bar' | translate }}</mat-option>
          <mat-option value="line">{{ 'components.custom-charts.type-line' | translate }}</mat-option>
          <mat-option value="pie">{{ 'components.custom-charts.type-pie' | translate }}</mat-option>
          <mat-option value="scatter">{{ 'components.custom-charts.type-scatter' | translate }}</mat-option>
          <mat-option value="heatmap">{{ 'components.custom-charts.type-heatmap' | translate }}</mat-option>
        </mat-select>
        <mat-icon matSuffix class="text-muted">insert_chart</mat-icon>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-end p-2 border-top">
    <button mat-button mat-dialog-close class="mr-2 rounded-3">
      {{ 'generic.buttons.reset' | translate }}
    </button>
    <button mat-flat-button color="primary" [disabled]="!editChartTitle || !editChartTitle.trim()" (click)="saveChart(selectedChartToEdit)" mat-dialog-close class="rounded-3">
      {{ 'generic.buttons.save' | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #infoDialog>
  <h2 mat-dialog-title class="d-flex align-items-center m-0 p-3 fw-bold border-bottom brand-title">
    <mat-icon class="mr-2 brand-icon">info</mat-icon>
    {{ 'components.custom-charts.analysis-details' | translate }}
  </h2>
  <mat-dialog-content class="p-3">
    <div class="info-item mb-3">
      <div class="small-title text-muted mb-1">{{ 'components.custom-charts.chart-title' | translate }}</div>
      <div class="info-val fw-bold text-dark">{{ selectedChartForInfo?.title }}</div>
    </div>
    <div class="info-item mb-3">
      <div class="small-title text-muted mb-1">{{ 'components.custom-charts.chart-type' | translate }}</div>
      <div class="info-val fw-bold text-dark d-flex align-items-center">
        <mat-icon class="mr-1 text-primary small-icon" style="font-size: 20px; width: 20px; height: 20px; vertical-align: middle;">
          {{ selectedChartForInfo?.chart_type === 'pie' ? 'pie_chart' : (selectedChartForInfo?.chart_type === 'line' ? 'show_chart' : (selectedChartForInfo?.chart_type === 'heatmap' ? 'grid_on' : 'bar_chart')) }}
        </mat-icon>
        {{ 'components.custom-charts.type-' + selectedChartForInfo?.chart_type | translate }}
      </div>
    </div>
    <div class="info-item mb-3">
      <div class="small-title text-muted mb-1">{{ 'components.custom-charts.x-axis' | translate }}</div>
      <div class="info-val fw-bold text-dark">{{ getDimensionLabel(selectedChartForInfo?.settings?.x_axis) }}</div>
    </div>
    <div class="info-item">
      <div class="small-title text-muted mb-1">{{ 'components.custom-charts.group-by' | translate }}</div>
      <div class="info-val fw-bold text-dark">{{ getDimensionLabel(selectedChartForInfo?.settings?.group_by) }}</div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-end p-2 border-top">
    <button mat-flat-button color="primary" mat-dialog-close class="rounded-3">
      {{ 'generic.buttons.close' | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>
